<div [formGroup]="formGroup">
  <label [for]="controlName" class="block text-sm font-medium">{{ label }}</label>
  <input
    [id]="controlName"
    [formControlName]="controlName"
    type="date"
    class="border-1 form-input mt-1 block w-full rounded-md border-dark-blue shadow-sm focus:border-medium-green focus:ring focus:ring-medium-green focus:ring-opacity-50"
  />
  <app-form-errors [fieldName]="controlName" />
</div>
